// About.js
import React from "react";
const About = () => {
  return (
    <div className="all-center">
      <div className="textclass">
        <h1 className="x-large text-primary">Github Finder App</h1>
        <p className="lead">
          This is a simple web application for finding Github users and their
          repositories.
        </p>
      </div>
    </div>
  );
};
export default About;
